import script from "./PollutantValue.vue?vue&type=script&setup=true&lang=js"
export * from "./PollutantValue.vue?vue&type=script&setup=true&lang=js"

import "./PollutantValue.vue?vue&type=style&index=0&id=1701731c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1701731c"]])

export default __exports__